import { render, staticRenderFns } from "./floatback.vue?vue&type=template&id=43cdcf4c&scoped=true&"
import script from "./floatback.vue?vue&type=script&lang=js&"
export * from "./floatback.vue?vue&type=script&lang=js&"
import style0 from "./floatback.vue?vue&type=style&index=0&id=43cdcf4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cdcf4c",
  null
  
)

export default component.exports